import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { User } from 'oidc-client';
import { bindActionCreators, Dispatch } from 'redux';
import { AppState } from '../../store';
import { Row } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router';
import * as DashboardStore from '../../store/Dashboard';
import DashboardView from './DashboardView';
import NavMenuSharableLink from '../Common/NavMenuSharableLink';
import { PowerBiObjectType } from '../../types/Common/PowerBiObjectType';
import { ExportFileType } from '../../types/Common/Enums/ExportFileType';

type DashboardViewerProps = {
    dispatch: Dispatch;
    dashboardState: DashboardStore.DashboardState;
    user: User;
    actions: typeof DashboardStore.actionCreators;
}
& RouteComponentProps<{dashboardId: string}>;

interface DashboardViewerState {
    isLoading: boolean;
}

class DashboardViewer extends React.Component<DashboardViewerProps, DashboardViewerState> {
    private dashboardViewChildRef: React.RefObject<DashboardView>;
    public constructor(props: DashboardViewerProps) {
        super(props);
        this.state = {
            isLoading: true,
        };
        this.dashboardViewChildRef = React.createRef();
    }
    

    public componentDidMount() {
        this.props.actions.unloadDashboardDetails();
        this.ensureDataFetched();
    }

    public componentDidUpdate() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {
        this.props.actions.requestDashboardMinimalDetails(this.props.match.params.dashboardId);
        
        if (this.state.isLoading && !this.props.dashboardState.isLoadingDetails && this.props.dashboardState.isLoadedDetails) {
            this.setState({isLoading: false});
        }
    }

    // Handle the NavMenu click for full screen and pass on the request to the child component
    onFullScreenClick? = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        this.dashboardViewChildRef?.current?.powerBiEmbedFullScreen();
    };

    showExportFileRequestModal = (exportFileType: ExportFileType) => {
        this.dashboardViewChildRef?.current?.exportFileRequest(exportFileType);
    }

    public render() {
        let dashboard = this.props.dashboardState.data.find(x => x.id === this.props.match.params.dashboardId);
        let windowInnerHeight = window.innerHeight;

        return (
            <React.Fragment>
                <div id="detailsContainer">
                <NavMenuSharableLink 
                    powerBiObjectType={PowerBiObjectType.Report}
                    documentId={dashboard?.id}
                    documentTitle={dashboard?.displayName} 
                    onFullScreenClick={this.onFullScreenClick}
                    showExportFileRequestModal={this.showExportFileRequestModal}
                />
                <Row>
                <DashboardView
                    ref={this.dashboardViewChildRef}
                    dashboardId={this.props.match.params.dashboardId}
                    {...this.props}
                />
                </Row>
                </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state: AppState) {
    return {
        dashboardState: state.dashboard,
        user: state.oidc.user,
    };
}

export default connect(
    mapStateToProps,
    (dispatch) => {
        return {
            dispatch: dispatch,
            actions: bindActionCreators(Object.assign(
                {},
                DashboardStore.actionCreators
            ), dispatch )
        }
    },
)(DashboardViewer as any);
